import { render, staticRenderFns } from "./DueDatedRequestsBySponsore.vue?vue&type=template&id=6b20747d"
import script from "./DueDatedRequestsBySponsore.vue?vue&type=script&lang=js"
export * from "./DueDatedRequestsBySponsore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports